import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { SearchDataV2Query, SearchDataV2QueryVariables } from './api.graphql';
import { SearchDataV2 } from './api.graphql';

export type SearchPageFeatureConfigs = SearchDataV2Query['featureConfigs'];

export type SearchPageData = {
	viewer: SearchDataV2Query['viewer'];
	featureConfigs: SearchPageFeatureConfigs;
	countries: SearchDataV2Query['countries'];
};

export async function getSearchPageData({ gql: { fetch } }: UtilityContext): Promise<SearchPageData> {
	const { data } = await fetch<SearchDataV2Query, SearchDataV2QueryVariables>({
		query: SearchDataV2,
		rejectOnError: true,
	});

	return { viewer: data.viewer, featureConfigs: data.featureConfigs, countries: data.countries };
}
